const features = [
  {
    icon: "ri-global-line",
    title: "VPN",
    description:
      "Access more than 1000 secure servers in any country. Encrypts your traffic and hides your real IP address, protecting you from tracking and data interception especially on public Wi-Fi networks.",
  },
  {
    icon: "ri-shield-flash-line",
    title: "AdBlock",
    description:
      "Block ads, trackers, and adult content with customizable rules. Works in browsers and apps to provide a clean, fast, and safe browsing experience across all your devices.",
  },
  {
    icon: "ri-fingerprint-line",
    title: "Check IP",
    description:
      "Instantly check all your connection information: real IP address, device, geolocation, timezone, provider, and country. Stay informed about what the internet sees about you.",
  },
  {
    icon: "ri-speed-line",
    title: "Speed Test",
    description:
      "Test your internet connection speed in real time: download, upload, and ping. Know exactly how fast your connection is and optimize your online experience.",
  },
];

export default function SecurityFeaturesGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-900 mb-4 font-heading">
            Powerful Protection Tools
          </h2>
          <p className="text-lg text-foreground-600 max-w-3xl mx-auto">
            Four essential tools in one app to keep your online activity private, secure, and fast
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-8">
          {features.map((feature, idx) => (
            <div
              key={idx}
              className="bg-white p-6 md:p-8 rounded-xl border border-background-200 hover:shadow-lg transition-shadow duration-300"
            >
              <div className="w-12 h-12 bg-primary-500 rounded-lg flex items-center justify-center mb-6">
                <i className={`${feature.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-xl font-semibold text-foreground-900 mb-4">
                {feature.title}
              </h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}